module.exports = __webpack_public_path__ + "img/ico_status_normal.ce60cb69.svg";